import React from 'react';
import { useClient } from '../../context/ClientContext';
import CampaignCards from '../simple/CampaignCards';
import BrandCampaign from '../simple/BrandCampaign';
import AdPerformance from '../simple/AdPerformance';
import AdCopyWinners from '../simple/AdCopyWinners';
import TopKeywords from '../simple/TopKeywords';
import DeviceBreakdown from '../simple/DeviceBreakdown';
import QualityScore from '../simple/QualityScore';
import SearchTermIntent from '../simple/SearchTermIntent';
import NetworkBreakdown from '../simple/NetworkBreakdown';
import AuctionInsights from '../simple/AuctionInsights';

export default function CampaignsPage({ campaignCards, brandCampaign, refreshKey, dateRange }) {
  const { dataSources } = useClient();
  const features = dataSources.features || {};

  return (
    <div className="space-y-6">
      {campaignCards?.length > 0 ? (
        <CampaignCards data={campaignCards} />
      ) : (
        features.brandCampaign && brandCampaign && <BrandCampaign data={brandCampaign} />
      )}

      <DeviceBreakdown key={`device-${refreshKey}`} dateRange={dateRange} />

      <AdCopyWinners key={`adcopy-${refreshKey}`} dateRange={dateRange} />

      {features.adPerformance !== false && (
        <AdPerformance key={`ads-${refreshKey}`} dateRange={dateRange} />
      )}

      <QualityScore key={`qs-${refreshKey}`} />

      <SearchTermIntent key={`intent-${refreshKey}`} dateRange={dateRange} />

      <NetworkBreakdown key={`network-${refreshKey}`} dateRange={dateRange} />

      <AuctionInsights key={`auction-${refreshKey}`} dateRange={dateRange} />

      {features.topKeywords !== false && (
        <TopKeywords key={`kw-${refreshKey}`} dateRange={dateRange} />
      )}
    </div>
  );
}
